export default "__VITE_ASSET__DZ$o1iuV__"